module.exports = __webpack_public_path__ + "img/customer-icon-14.54df2318.png";